import React, { CSSProperties, useState } from 'react';
import { EditIcon } from '../Icons/EditIcon';
import { Info } from '../Icons/Info';
import { Popup } from '../Popup/Popup';

type LabelProps = {
  children?: string | JSX.Element;
  onClick?: () => void;
  title: string | undefined;
  value: string | undefined;
  icon?: boolean;
  tooltip?: string;
  style?: CSSProperties;
  permission?: boolean;
};

const Label: React.FC<LabelProps> = ({
  children,
  onClick,
  title = '',
  value = '',
  icon,
  tooltip = '',
  style,
  permission = false,
}: LabelProps): JSX.Element => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const conditionToShowEditIcon =
    title === 'EMAIL' ||
    (title === 'NAME' && !permission) ||
    (title === 'PASSWORD' && !permission);

  return (
    <div className="label">
      <div className="label-title">
        {title}{' '}
        {icon ? (
          <span
            className="label-title-spn"
            onClick={() => setPopupIsOpen(true)}
            onMouseEnter={() => setPopupIsOpen(true)}
            onMouseLeave={() => setPopupIsOpen(false)}
          >
            <Info active className="label-title-spn__icon" />
          </span>
        ) : null}
        <Popup
          open={popupIsOpen}
          className="label-title-iconBlock-popup"
          text={tooltip}
          style={style}
        />
      </div>
      {conditionToShowEditIcon ? (
        <></>
      ) : (
        <EditIcon onClick={onClick} className="label-editIcon" />
      )}
      {children}
      <div className="label-text">{value}</div>
    </div>
  );
};

export default Label;
